import React from "react";
import { Button } from "antd";

const CustomButton = ({ btntext = "Хадгалах", styles, loading = false, ...props }) => {
  return (
    <Button type="primary" disabled={loading} style={{ right: 0, minWidth: "93px", ...styles }} {...props}>
      {btntext}
    </Button>
  );
};

export default CustomButton;
